<template>
  <div>
    <div class="add">
      <div class="left"></div>
      <div class="right" @click="clickAddKey">
        <i class="el-icon-plus iAdd"></i>
        <div class="text">添加链接方</div>
      </div>
    </div>
    <div class="table">
      <el-table
        ref="multipleTable"
        @sort-change="changeTableSort"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="{ background: '#fff', color: '#333333' }"
      >
        <el-table-column label="序号" align="center" type="index" width="80">
          <template></template>
        </el-table-column>
        <el-table-column label="编号" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.clueCode }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="链接方信息" align="center">
          <template slot-scope="scope">
            <div class="msg">{{ scope.row.linkSideName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="属性" align="center">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.property == 0">个人</div>
              <div v-if="scope.row.property == 1">机构/企业</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="与企业关系" align="center">
          <template slot-scope="scope">
            <!-- 属性为个人 -->
            <div v-if="scope.row.property == 0">
              <div v-if="scope.row.andEnterpriseRelation == 0">企业员工</div>
              <div v-if="scope.row.andEnterpriseRelation == 1">前同事</div>
              <div v-if="scope.row.andEnterpriseRelation == 2">同学</div>
              <div v-if="scope.row.andEnterpriseRelation == 3">好友</div>
              <div v-if="scope.row.andEnterpriseRelation == 4">同乡</div>
              <div v-if="scope.row.andEnterpriseRelation == 5">亲戚</div>
              <div v-if="scope.row.andEnterpriseRelation == 6">其他</div>
            </div>
            <!-- 属性为企业 -->
            <div v-if="scope.row.property == 1">
              <div v-if="scope.row.andEnterpriseRelation == 0">协商方</div>
              <div v-if="scope.row.andEnterpriseRelation == 1">投资方</div>
              <div v-if="scope.row.andEnterpriseRelation == 2">FA(投资公司)</div>
              <div v-if="scope.row.andEnterpriseRelation == 3">供应商</div>
              <div v-if="scope.row.andEnterpriseRelation == 4">甲方</div>
              <div v-if="scope.row.andEnterpriseRelation == 5">园区</div>
              <div v-if="scope.row.andEnterpriseRelation == 6">其他</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="联系人" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.linkman }}</div>
          </template>
        </el-table-column>
        <el-table-column label="电话" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.phone }}</div>
          </template>
        </el-table-column>
        <el-table-column label="微信" align="center">
          <template slot-scope="scope"
            ><div>
              {{ scope.row.weChat }}
            </div></template
          >
        </el-table-column>
        <el-table-column label="邮箱" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.email }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="创建时间" sortable="custom" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.createTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" prop="最近更新时间" label="更新时间" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.updateTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140">
          <template slot-scope="scope">
            <div class="operation">
              <div class="compile" @click="clickCompileKey(scope.row)">编辑</div>
              <div class="remove" @click="clickRemoveKey(scope.row)">删除</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.baseParam.pageNum"
        :page-sizes="[10, 30, 50]"
        :page-size="query.baseParam.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <div class="dialog">
      <el-dialog @close="dialogClose" :visible.sync="dialogVisible" width="30%">
        <div class="dialogHead">
          <div class="line"></div>
          <div class="txt" v-if="echo == 0">添加链接方</div>
          <div class="txt" v-else>编辑链接方</div>
        </div>
        <div class="form">
          <el-form ref="form" :model="form" label-width="160px" :rules="rules">
            <el-form-item prop="linkSideName" label="链接方信息：">
              <el-input v-model="form.linkSideName"></el-input>
            </el-form-item>

            <el-form-item prop="property" label="属性：">
              <el-select
                @change="addProperty"
                v-model="form.property"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in propertyList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系人：">
              <el-input v-model="form.linkman"></el-input>
            </el-form-item>

            <el-form-item prop="phone" label="电话：">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>

            <el-form-item prop="weChat" label="微信：">
              <el-input v-model="form.weChat"></el-input>
            </el-form-item>
            <el-form-item prop="email" label="邮箱：">
              <el-input v-model="form.email"></el-input>
            </el-form-item>

            <el-form-item prop="email" label="与企业关系：">
              <el-select
                v-model="form.andEnterpriseRelation"
                filterable
                placeholder="请选择"
                v-if="propertyActive == 0"
              >
                <el-option
                  v-for="item in andEnterpriseRelation1"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>

              <el-select
                v-model="form.andEnterpriseRelation"
                filterable
                placeholder="请选择"
                v-if="propertyActive == 1"
              >
                <el-option
                  v-for="item in andEnterpriseRelation2"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <div class="button">
            <div class="add" @click="clickAddMsg" v-if="echo == 0">添加</div>
            <div class="add" @click="clickAddMsg" v-if="echo == 1">保存</div>
            <div class="cancel" @click="dialogVisible = false">取消</div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  getLinksParty,
  saveLinksParty,
  deleteLinksParty,
  updateLinksParty,
  getClueScheduleTime
} from '../../../../api/businessCenter.js'

const defaultFormObj = Object.freeze({
  andEnterpriseRelation: '', // 与企业关系(属性为个人：0->企业员工；1->前同事；2->同学；3->好友；4->同乡；5->亲戚；6->其他。属性为企业：0->协商方；1->投资方；2->FA(投资公司)；3->供应商；4->甲方；5->园区；6->其他
  clueCode: '', // 线索编号
  createName: '',
  createTime: '',
  email: '', // 邮箱
  id: 0,
  linkman: '', // 联系人（个人）
  linkSideName: '', // 链接方信息
  phone: '', // 电话
  property: '0', // 属性0->个人；1->机构/企业
  updateName: '',
  updateTime: '',
  weChat: '' // 微信
})

export default {
  components: {},
  data() {
    //这里存放数据
    return {
      total: 0,
      tableData: [],
      query: {
        baseParam: {
          pageNum: 1,
          pageSize: 10
        },
        order: 'desc',
        orderType: '0',
        clueCode: '',
        id: null
      },

      echo: null,
      dialogVisible: false,
      form: { ...defaultFormObj },
      rules: {
        linkSideName: [{ required: true, message: '请填写链接方信息' }]
      },
      propertyList: [
        {
          value: '个人',
          id: '0'
        },
        {
          value: '机构/企业',
          id: '1'
        }
      ],
      propertyActive: '0',
      // 属性个人
      andEnterpriseRelation1: [
        {
          value: '企业员工',
          id: '0'
        },

        {
          value: '前同事',
          id: '1'
        },

        {
          value: '同学',
          id: '2'
        },

        {
          value: '好友',
          id: '3'
        },

        {
          value: '同乡',
          id: '4'
        },

        {
          value: '亲戚',
          id: '5'
        },
        {
          value: '其他',
          id: '6'
        }
      ],
      // 属性企业
      andEnterpriseRelation2: [
        {
          value: '协商方',
          id: '0'
        },

        {
          value: '投资方',
          id: '1'
        },

        {
          value: 'FA(投资公司)',
          id: '2'
        },

        {
          value: '供应商',
          id: '3'
        },

        {
          value: '甲方',
          id: '4'
        },

        {
          value: '园区',
          id: '5'
        },
        {
          value: '其他',
          id: '6'
        }
      ],
      row: {}
    }
  },

  computed: {},

  watch: {},
  created() {
    let row1 = sessionStorage.getItem('row1')
    if (row1) {
      this.row = JSON.parse(row1)
    } else {
      this.row = JSON.parse(this.$route.query.row)
    }
    this.search()
  },

  methods: {
    async search() {
      this.query.clueCode = this.row.clueCode
      const { data: res } = await getLinksParty(this.query)
      if (res.resultCode == 200) {
        this.tableData = res.data.list
        this.total = res.data.total
        this.$emit('quantity', res.data.total)
      }
    },
    initDay() {
      const date = new Date() // 得到当前时间
      const year = date.getFullYear() // 年
      const mont = date.getMonth() + 1 // 月
      const dat = date.getDate() // 日
      const hour = date.getHours() // 时
      const minute = date.getMinutes() // 分
      const second = date.getSeconds() // 秒

      const monts = mont < 10 || mont === 0 ? '0' + mont : mont // 月
      const dats = dat < 10 || dat === 0 ? '0' + dat : dat // 日
      const hours = hour < 10 || hour === 0 ? '0' + hour : hour // 时
      const minutes = minute < 10 ? '0' + minute : minute // 分
      const seconds = second < 10 ? '0' + second : second // 秒
      return `${year}-${monts}-${dats} ${hours}:${minutes}:${seconds}`
    },
    // 表格排序
    changeTableSort(column) {
      if (column.order == 'ascending') {
        this.query.order = 'asc'
      } else if (column.order == 'descending') {
        this.query.order = 'desc'
      }

      if (column.prop == '创建时间') {
        this.query.orderType = 0
      } else if (column.prop == '更新时间') {
        this.query.orderType = 1
      }

      this.search()
    },
    // 添加链接方的点击按钮
    clickAddKey() {
      this.form = { ...defaultFormObj }
      this.echo = 0
      this.dialogVisible = true
    },
    // 填写完信息后的添加按钮
    clickAddMsg() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.echo == 0) {
            // 新增
            this.form.createTime = this.initDay()
            this.form.clueCode = this.row.clueCode
            this.form.createName = this.row.createName
            const { data: res } = await saveLinksParty(this.form)
            if (res.resultCode == 200) {
              this.$message.success('新增成功')
              this.search()
              this.dialogVisible = false
              this.form = { ...defaultFormObj }
            }
          } else if (this.echo == 1) {
            // 编辑
            this.form.createTime = this.initDay()
            this.form.clueCode = this.row.clueCode
            this.form.createName = this.row.createName
            const { data: res } = await updateLinksParty(this.form)
            if (res.resultCode == 200) {
              this.dialogVisible = false
              this.$message.success('编辑成功')
              this.form = { ...defaultFormObj }
              this.search()
            }
          }
        }
      })
    },
    // 编辑链接方
    async clickCompileKey(row) {
      this.echo = 1
      this.query.id = row.id
      const { data: res } = await getLinksParty(this.query)
      if (res.resultCode == 200) {
        this.form = res.data.list[0]
        this.query.id = ''
      }
      this.addProperty()
      this.dialogVisible = true
    },
    // 删除链接方
    async clickRemoveKey(row) {
      const { data: res } = await deleteLinksParty({
        id: row.id
      })
      if (res.resultCode == 200) {
        this.$message.success('删除成功')
        this.search()
      }
    },
    handleSizeChange(val) {
      this.query.baseParam.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.query.baseParam.pageNum = val
      this.search()
    },
    // dialog 关闭的回调
    dialogClose() {
      if (this.echo == 0) {
        this.propertyActive = '0'
        this.form = { ...defaultFormObj }
      }
    },
    // 属性的选择
    addProperty() {
      this.propertyActive = this.form.property
    }
  },

  mounted() {}
}
</script>
<style scoped lang="less">
.add {
  height: 60px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 87px;
  .right {
    background-color: #17757a;
    border-radius: 4px;
    width: 98px;
    height: 32px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
    .text {
      margin-left: 3px;
    }
    .iAdd {
      transform: translateY(1px);
    }
  }
}
.table {
  box-sizing: border-box;
  background-color: #fff;

  .operation {
    display: flex;
    justify-content: space-around;
    .compile {
      font-size: 12px;
      font-weight: 400;
      color: #17757a;
      cursor: pointer;
    }
    .remove {
      font-size: 12px;
      font-weight: 400;
      color: #fa5050;
      cursor: pointer;
    }
  }
}

/deep/.el-dialog__header {
  padding: 0;
}
/deep/.el-dialog__body {
  padding: 0 0 30px 0px;
}
.pagination {
  width: 100%;
  height: 120px;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialogHead {
  display: flex;
  align-items: center;
  height: 54px;
  padding-left: 16px;
  .line {
    width: 4px;
    height: 20px;
    background-color: #17757a;
    border-radius: 2px;
    margin-right: 8px;
  }
  .txt {
    color: #333333;
    font-size: 16px;
    font-weight: 500;
  }
}

.dialog {
  .form {
    /deep/.el-form-item__content {
      height: 32px;
      line-height: 32px !important;
    }
    /deep/ .el-form-item__content .el-input__inner {
      height: 32px;
      line-height: 32px;
      width: 80%;
    }
    /deep/ .el-form-item__content .el-select {
      height: 32px;
      line-height: 32px;
      width: 50%;
    }
    /deep/ .el-select .el-input__inner {
      width: 100%;
    }
    /deep/ .el-form-item__label {
      line-height: 32px;
    }
    // /deep/.el-form-item {
    //   margin-bottom: 12px;
    // }
  }
}
.button {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  .add {
    width: 64px;
    height: 33px;
    border-radius: 4px;
    background-color: #17757a;
    font-size: 12px;
    color: #fff;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    cursor: pointer;
  }
  .cancel {
    width: 64px;
    height: 33px;
    border-radius: 4px;
    border: 1px solid #17757a;
    font-size: 12px;
    color: #17757a;
    font-weight: 400;
    margin-left: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
</style>
